import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { TeamsTeamMultiSelectorDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface Props {
  selectedTeamsIds: string[] | null
  disabled: boolean
  onSelectedTeamsChanged: (ids: string[]) => void
  mandatory?: boolean
  scopedTeamIds?: string[]
}

const TeamMultiselector = ({
  selectedTeamsIds,
  disabled,
  onSelectedTeamsChanged,
  mandatory,
  scopedTeamIds,
}: Props) => {
  const ids = scopedTeamIds ? scopedTeamIds : []

  const { data } = useQuery(TeamsTeamMultiSelectorDocument, {
    variables: { ids },
  })

  const teams = data?.teams?.teams || []

  const [teamsIds, setTeamsIds] = useState(selectedTeamsIds)

  const handleChangeTeams = (ids: string[]) => {
    setTeamsIds(ids)
    onSelectedTeamsChanged(ids)
  }

  const teamOptions = teams.map((team) => {
    return (
      <Selector.Option
        key={team.id}
        value={team.id}
        label={team.name}
        searchValue={team.name}
        isDisabled={disabled}
        isChecked={teamsIds?.includes(team.id)}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {team.name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={i18n.t('settings.permissions.visibility.choices.dynamic_group_options.team')}
      blankLabel={i18n.t('common.empty')}
      allSelectedLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      searchPlaceholder={i18n.t('common.search')}
      icon="manager"
      maxHeight="s300"
      value={teamsIds ? teamsIds : []}
      onChange={(ids) => handleChangeTeams(ids as string[])}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
      isDisabled={disabled}
      mandatory={mandatory}
    >
      {teamOptions}
    </Selector.Popover>
  )
}
export default observer(TeamMultiselector)
